// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';

export const NAVIGATION_TOP_OFFSET = -100;

const S = {
  NavigationTitle: styled.div`
    color: #434343;
    cursor: pointer;
    display: flex;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 10px;
    margin-left: 18px;
    margin-top: 4px;
  `,
  NavigationHighLight: styled.div<{ isFocus: boolean }>`
  ${props => (props.isFocus) ? 'background: #FFD163; border-radius: 4px;' : null};
    margin-left: 44px;
    display: flex;
    width: 153px;
    height: 34px;
  `
}

const NavigationContent = (props: any): JSX.Element => {
  const item = props.item;
  const setNavigationFocus = props.setNavigationFocus;
  const isFocus = props.isFocus;
  const setNavigationClickToRender= props.setNavigationClickToRender;

  const handleNavigate = (item: any) => {
    if (item.title == 'Overview') {
      return null;
    } else {
      setNavigationFocus(item.title);
      localStorage.setItem('lastFocus', item.title);
      if (item.title == 'Scenario') {
        setNavigationClickToRender('README.md')
        localStorage.setItem('mdPath', 'README.md');
      } else {
        const mdPath = `${item.path}/README.md`;
        localStorage.setItem('mdPath', mdPath);
        setNavigationClickToRender(mdPath);
      }
    }
  }

  return (
    <>
      <S.NavigationHighLight isFocus={isFocus}>
        <S.NavigationTitle onClick={() => handleNavigate(item)}>
          {item.title}
        </S.NavigationTitle>
      </S.NavigationHighLight>
    </>
  )
}

const Navigation = (props: any): JSX.Element => {
  const focusItem = props.navigationFocus;
  const setNavigationFocus = props.setNavigationFocus;
  const navigationList = props.navigationList;
  const isChallengeStart = props.isChallengeStart;
  const setNavigationClickToRender = props.setNavigationClickToRender;

  if (!isChallengeStart) {
    const NavigationContents = navigationList.map((item: any, index: number) => {
      if (item.title == 'Overview') {
        return (<NavigationContent key={index} isFocus={true} item={item} setNavigationFocus={setNavigationFocus} setNavigationClickToRender={setNavigationClickToRender} ></NavigationContent>);
      } else {
        return (<div key={index}></div>);
      }
    })
    return (
      <>
        {NavigationContents}
      </>
    )
  } else {
    const NavigationContents = navigationList.map((item: any, index: number) => {
      switch (item.title) {
        case focusItem:
          return (<NavigationContent key={index} isFocus={true} item={item} setNavigationFocus={setNavigationFocus} setNavigationClickToRender={setNavigationClickToRender} ></NavigationContent>);
        case 'Overview':
          return (<div key={index}></div>);
        default:
          return (<NavigationContent key={index} isFocus={false} item={item} setNavigationFocus={setNavigationFocus} setNavigationClickToRender={setNavigationClickToRender} ></NavigationContent>);
      }
    })
    return (
      <>
        {NavigationContents}
      </>
    )
  }
}

export default Navigation;
